// 005 FR-010: the server's categories in their order, with their orderable flag. Until they load,
// School Books and Stationery show as browsable and Uniforms as "Coming soon" (the launch state).
import { useEffect, useState } from "react";

import type { Api } from "@/api/types";

import { useShopping } from "./shopApi";

const LAUNCH: Api["Category"][] = [
  {
    code: "SCHOOL_BOOKS",
    name: "School Books",
    displayOrder: 1,
    orderable: true,
  },
  { code: "STATIONERY", name: "Stationery", displayOrder: 2, orderable: true },
  { code: "UNIFORMS", name: "Uniforms", displayOrder: 3, orderable: false },
];

export function useCategories(): Api["Category"][] {
  const { client } = useShopping();
  const [items, setItems] = useState<Api["Category"][] | null>(null);
  useEffect(() => {
    let live = true;
    client.listCategories().then(
      (list) =>
        live &&
        setItems(
          [...list.items].sort((a, b) => a.displayOrder - b.displayOrder),
        ),
      () => {},
    );
    return () => {
      live = false;
    };
  }, [client]);
  return items ?? LAUNCH;
}

export const isOrderable = (
  list: Api["Category"][],
  code: Api["CategoryCode"],
) => list.find((c) => c.code === code)?.orderable ?? false;
